import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MenuGestionarSolicitud } from '../MenuInternacionalizacion';
import TareasTerminadas from '../../../general/TareasTerminadas';
import { Checkbox, Dialog, DialogActions, DialogContent, FormControl, Grid, List, ListItem, ListItemIcon, ListItemText, ListSubheader, makeStyles, TextField } from '@material-ui/core';
import { BtnForm } from '../../../general/BotonesAccion';
import { consulta, formulario, generarFiltros, obtenerEstadosProceso, obtenerValoresFiltros } from '../../../../global/js/funciones';
import AppBarModal from '../../../general/AppBarModal';
import CustomDropzone from '../../../general/CustomDropzone';
import BuscarSelect from '../../../general/BuscarSelect';
import { ESTADOS, CODIGOS_TIPO_POSTULACION, ESTADO_MARCAR_UNIVERSIDAD, TIPOS_MARCAR_UNIVERSIDAD, UNIVERSIDADES, ADJUNTO_SOLO_PARA_TIPOS } from '../helper';
import emma_w from '../../../../global/imagenes/emma_w.png';
import { TIPOS_FORMS_MOVILIDAD, ITEMS_CORRECCION_MOV_EST } from '../../registro/helper';
import { connect } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

function RenderEstados({ estados_siguiente, estado, cambiarSeleccion, exigeAdjunto }) {
  const classes = useStyles();
  return (
    <List className = { classes.root } subheader = {
      <ListSubheader component = "div" >
        Seleccione Estado
      </ListSubheader>
    }>
      {estados_siguiente.map(({ secundario }) => {
          let { codigo, nombre, valorh } = secundario;
          // Si el estado exige adjuntos (lo valida el backend en SolicitudGestionar) se
          // anuncia aqui para que no sorprenda al enviar.
          let exige_adjunto = exigeAdjunto(codigo);
          let aviso_adjunto = (valorh || '').trim() || 'Requiere adjuntar un documento';
          return (
            <ListItem key = { codigo } role = { undefined } dense button onClick = { () => cambiarSeleccion(codigo) } >
              <ListItemIcon>
                <Checkbox edge = "start" checked = { estado === codigo } tabIndex = { -1 } disableRipple />
              </ListItemIcon>
              <ListItemText id = { codigo } primary = { nombre } secondary = { exige_adjunto ? aviso_adjunto : '' } />
            </ListItem>
          );
        })
      }
    </List>
  );
}

function RenderUniversidades({ universidades, universidad, marcada, cambiarSeleccion }) {
  const classes = useStyles();
  const etiqueta = ({ id }) => {
    let partes = ['Postuló el estudiante'];
    if (id === marcada) partes.push('Asignada actualmente');
    return partes.join(' · ');
  }
  return (
    <List className = { classes.root } subheader = {
      <ListSubheader component = "div" >
        Seleccione la institución asignada
      </ListSubheader>
    }>
      {universidades.map((universidad_item) => (
        <ListItem key = { universidad_item.id } role = { undefined } dense button onClick = { () => cambiarSeleccion(universidad_item.id) } >
          <ListItemIcon>
            <Checkbox edge = "start" checked = { universidad === universidad_item.id } tabIndex = { -1 } disableRipple />
          </ListItemIcon>
          <ListItemText id = { `universidad_${universidad_item.id}` } primary = { universidad_item.nombre } secondary = { etiqueta(universidad_item) } />
        </ListItem>
      ))}
    </List>
  );
}

function RenderOpcionesEditar({ opciones, estado, cambiarSeleccion }) {
  const classes = useStyles();
  return (
    <List className = { classes.root } subheader = {
      <ListSubheader component = "div" >
        Seleccione las opciones
      </ListSubheader>
    }>
      {opciones.map((data) => {
          let { codigo, nombre } = data;
          return (
            <ListItem key={codigo} role={undefined} dense button onClick={() => cambiarSeleccion(codigo)} >
              <ListItemIcon>
                <Checkbox edge="start" checked={estado.includes(codigo)} tabIndex={-1} disableRipple />
              </ListItemIcon>
              <ListItemText id={codigo} primary={nombre} />
            </ListItem>
          );
        })
      }
    </List>
  );
}

class SolicitudesGestionar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cargando: true,
      estado: '',
      observacion: '',
      seleccion: 'gestion',
      titulo_res: 'Cargando..',
      archivos: [],
      estados_siguiente: [],
      modal_correccion: false,
      data_opc_editar: [],
      opciones_editar: [],
      universidades: [],
      universidad_sel: '',
      universidad_actual: '',
    }
  }

  async obtenerUniversidades(solicitud) {
    let marca_universidad = solicitud && solicitud.tipo_solicitud && TIPOS_MARCAR_UNIVERSIDAD.indexOf(solicitud.tipo_solicitud.codigo) >= 0;
    let en_aceptado = solicitud && solicitud.estado_actual && solicitud.estado_actual.codigo === ESTADO_MARCAR_UNIVERSIDAD;
    let vacio = { universidades: [], universidad_actual: '' };
    if (!marca_universidad || !en_aceptado) return vacio;
    let f = await generarFiltros([{ 'llave': 'solicitud', 'valor': solicitud.id }]);
    let mov = await new Promise(resolve => {
      consulta(`api/v1.0/internacionalizacion/solicitud/mov_estudiantil?${f}`, null, null, (error, estado, resp) => {
        resolve((!error && estado === 200 && resp.length > 0) ? resp[0] : null);
      });
    });
    if (!mov) return vacio;

    let universidades = [mov.universidad_1, mov.universidad_2, mov.universidad_3, mov.universidad_4]
      .filter(Boolean).map(u => ({ id: u.id, nombre: u.nombre, postulada: true }));

    let ids_convocatoria = (mov.convocatoria && mov.convocatoria.universidades_destino) || [];
    let pendientes = ids_convocatoria.filter(id => !universidades.some(u => u.id === id));
    if (pendientes.length > 0) {
      let catalogo = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': UNIVERSIDADES }, { 'llave': 'estado', 'valor': 1 }]);
      pendientes.forEach(id => {
        let encontrada = (catalogo || []).filter(u => u.id === id)[0];
        if (encontrada) universidades.push({ id: encontrada.id, nombre: encontrada.nombre, postulada: false });
      });
    }
    return {
      universidades,
      universidad_actual: mov.universidad_seleccionada ? mov.universidad_seleccionada.id : '',
    };
  }

  marcarUniversidad(id, universidad) {
    return new Promise(resolve => {
      consulta(`api/v1.0/internacionalizacion/solicitud/${id}/universidad_seleccionada`, { universidad }, 'put', (error, estado, resp) => {
        resolve({
          ok: !error && estado === 200,
          titulo: (resp && resp.titulo) || 'Ha ocurrido un error, contacte con el administrador.',
        });
      });
    });
  }

  async componentDidUpdate({ modalGestionarSolicitud }, { estado, modal_correccion }) {
    let { modalGestionarSolicitud: modalGestionarSolicitudNew, solicitud, usuario } = this.props;
    let { estado: estadoNew, modal_correccion: modal_correccionNew } = this.state;
    
    if (estadoNew !== estado) {
      this.setState({ observacion: '', cargando: false,});
      if (estadoNew == 'Est_Int_Cor') {
        this.setState({ cargando: true, modal_correccion: true })
        // Cada tipo de solicitud tiene su propia lista de items a corregir: movilidad
        // estudiantil usa su genérica propia; el resto, los formularios de registro
        // de movilidad marcados con valorb = 1.
        let es_mov_estudiantil = solicitud && solicitud.tipo_solicitud && CODIGOS_TIPO_POSTULACION.indexOf(solicitud.tipo_solicitud.codigo) >= 0;
        let filtros = es_mov_estudiantil
          ? [{ 'llave': 'generica', 'valor': ITEMS_CORRECCION_MOV_EST }, { 'llave': 'estado', 'valor': 1 }]
          : [{ 'llave': 'generica', 'valor': TIPOS_FORMS_MOVILIDAD }, { 'llave': 'estado', 'valor': 1 }, { 'llave': 'valorb', 'valor': '1' }];
        let data_opc_editar = await obtenerValoresFiltros(filtros);
        this.setState({ cargando: false, data_opc_editar })
      }
    }
    if (modalGestionarSolicitud !== modalGestionarSolicitudNew) {
      if (modalGestionarSolicitudNew) {
        this.reiniciarEstados();
        let estados_siguiente = await obtenerEstadosProceso(solicitud.tipo_solicitud.id, [{ 'llave': 'principal', 'valor': solicitud.estado_actual.id }, { 'llave': 'secundario__generica', 'valor': ESTADOS }]);
        // Quitar estado "Finalizado" si el perfil es Per_Int_N1
        if (usuario && usuario.perfil && usuario.perfil.codigo === 'Per_Int_N1') {
          estados_siguiente = estados_siguiente.filter(({ secundario }) => secundario.codigo !== 'Est_Int_Fin');
        }

        let { universidades, universidad_actual } = await this.obtenerUniversidades(solicitud);
        this.setState({ estado: '', mensaje: '', estados_siguiente, universidades,
          universidad_actual, universidad_sel: universidad_actual, cargando: false }
        );
      }
    }
  }

  // El estado destino puede exigir adjuntos (valorc = 'si'), salvo que solo los pida para
  // otros tipos (ADJUNTO_SOLO_PARA_TIPOS). El backend ya lo valida; esto evita que el
  // gestor llene el formulario y se lleve el rechazo al final.
  estadoExigeAdjunto = (codigo) => {
    let { estados_siguiente } = this.state;
    let { solicitud } = this.props;
    let elegido = (estados_siguiente || []).filter(({ secundario }) => secundario.codigo === codigo)[0];
    if (!elegido || elegido.secundario.valorc !== 'si') return false;
    let tipos = ADJUNTO_SOLO_PARA_TIPOS[codigo];
    return !tipos || (!!solicitud && !!solicitud.tipo_solicitud && tipos.indexOf(solicitud.tipo_solicitud.codigo) >= 0);
  }

  onSubmit = async () => {
    let { solicitud, gestionarSolicitud, actualizarMensaje, mostrarModalGestionarSolicitud, actualizarDataSolicitudes } = this.props;
    let { archivos, estado, observacion, opciones_editar, universidades, universidad_sel, universidad_actual } = this.state;
    let marcar = universidades.length > 0 && universidad_sel && universidad_sel !== universidad_actual;

    if (!estado && !marcar) {
      actualizarMensaje({ titulo: universidades.length > 0 ? 'Seleccione la institución asignada.' : 'Seleccione estado siguiente.', tipo: 'info', mostrar: true, tiempo: 6000 });
      return;
    }
    if (this.estadoExigeAdjunto(estado) && archivos.length === 0) {
      actualizarMensaje({ titulo: 'Este estado requiere adjuntar al menos un documento. Cárguelo en la pestaña de documentos.', tipo: 'info', mostrar: true, tiempo: 8000 });
      return;
    }
    this.setState({ cargando: true, titulo_res: 'Enviando..' });
    if (marcar) {
      let { ok, titulo } = await this.marcarUniversidad(solicitud.id, universidad_sel);
      actualizarMensaje({ titulo, tipo: ok ? 'success' : 'info', mostrar: true, tiempo: 6000 });
      if (!ok) return this.setState({ cargando: false, titulo_res: 'Cargando..' });
      this.setState({ universidad_actual: universidad_sel });
      if (!estado) {
        this.setState({ cargando: false, titulo_res: 'Cargando..' });
        if (actualizarDataSolicitudes) actualizarDataSolicitudes();
        mostrarModalGestionarSolicitud(false);
        return;
      }
    }
    let data = { observacion, estado, archivos, opciones_editar }
    await gestionarSolicitud(solicitud.id, data);
    // cambiarSeleccionProc('Reg_Mov_Int');
    // actualizarEstadosRegMovInt();
    // this.pintarEstados()
    this.setState({ cargando: false, titulo_res: 'Cargando..' });
    if (estado && archivos.length) await this.cargarArchivos(solicitud.id, archivos);
  }
  
  onSubmitMod = () => {
    let { solicitud, gestionarSolicitud, actualizarMensaje } = this.props;
    let { estado, observacion,  opciones_editar } = this.state;
    if (!opciones_editar.length > 0) actualizarMensaje({ titulo: `Debe seleccionar al menos una opción para continuar.`, tipo: 'info', mostrar: true, tiempo: 6000 });
    else {
      this.setState({ modal_correccion: false })
    }
  }

  agregarArchivos = (arc) => {
		let { archivos } = this.state;
		archivos = archivos.concat(arc);
		this.setState({ archivos });
	}

  cargarArchivos(id, archivos) {
		let { actualizarMensaje } = this.props;
		if (archivos.length === 0) return true;
		const data = new FormData();
		data.append(`total`, archivos.length);
    data.append(`tipo`, 0);
		archivos.map((file, index) => data.append(`archivo${index}`, file));
		formulario(`api/v1.0/internacionalizacion/solicitud/${id}/adjuntar`, data, 'post', (error, estado, resp) => {
			if (error) {
				const title = 'Ha ocurrido un error al adjuntar los archivos, contacte con el administrador.';
				const icon = 'error';
				actualizarMensaje({ titulo: title, tipo: icon, mostrar: true, tiempo: 6000 });
			}
		});
	}

  eliminarArchivo = (i) => {
		let { archivos } = this.state;
		let { actualizarMensaje } = this.props;
		archivos.splice(i, 1);
		this.setState({ archivos });
		actualizarMensaje({ titulo: `Archivo Retirado.`, tipo: 'success', mostrar: true, tiempo: 6000 });
	}

  onChange = ({ target }) => {
		let { value, name } = target;
		this.setState({
			[name]: value
		});
	}

  pintar() {
    let { seleccion } = this.state;
    return (
      <div>
        { seleccion === 'gestion' && this.pintarEstados() }
        { seleccion === 'adjuntos' && this.pintarAdjuntos() }
      </div>
    )
  }

  pintarAdjuntos() {
    let { archivos } = this.state;
    return <CustomDropzone archivos = { archivos } addFunction = { this.agregarArchivos } deleteFunction = { this.eliminarArchivo } />
  }

  // Lo que el buscador tiene por valor: null si lo elegido es una postulada.
  opcionOtraSeleccionada = () => {
    let { universidades, universidad_sel, universidad_actual } = this.state;
    let elegida = universidades.filter(u => !u.postulada && u.id === universidad_sel)[0];
    if (!elegida) return null;
    return {
      value: elegida.id,
      label: elegida.id === universidad_actual ? `${elegida.nombre} (asignada actualmente)` : elegida.nombre,
    };
  }

  pintarEstados() {
    let { estado, estados_siguiente, observacion, universidades, universidad_sel, universidad_actual } = this.state;
    let postuladas = universidades.filter(u => u.postulada);
    let otras = universidades.filter(u => !u.postulada);
    return (
      <Grid container>
        {
          estados_siguiente.length > 0 &&
          <Grid item xs = { 12 } xl = { 12 } sm = { 12 } md = { 12 } lg = { 12 }>
            <RenderEstados
              cambiarSeleccion = { (estado) => this.setState({ estado }) }
              estado = { estado }
              estados_siguiente = { estados_siguiente }
              exigeAdjunto = { this.estadoExigeAdjunto }
            />
          </Grid>
        }
        {
          postuladas.length > 0 &&
          <Grid item xs = { 12 } xl = { 12 } sm = { 12 } md = { 12 } lg = { 12 }>
            <RenderUniversidades
              cambiarSeleccion = { (universidad_sel) => this.setState({ universidad_sel }) }
              universidad = { universidad_sel }
              marcada = { universidad_actual }
              universidades = { postuladas }
            />
          </Grid>
        }
        {
          // Las demas plazas de la convocatoria: pueden ser decenas, asi que se
          // buscan en vez de listarse. Elegir aqui deselecciona las casillas de
          // arriba y al reves, porque la institucion asignada es una sola.
          otras.length > 0 &&
          <Grid item xs = { 12 } xl = { 12 } sm = { 12 } md = { 12 } lg = { 12 }
            style = { { padding: '8px 16px 16px 16px' } }>
            <BuscarSelect
              datos = { otras.map(({ id, nombre }) => ({
                value: id,
                label: id === universidad_actual ? `${nombre} (asignada actualmente)` : nombre,
              })) }
              valor = { this.opcionOtraSeleccionada() }
              cambiarEstado = { (opcion) => this.setState({ universidad_sel: opcion ? opcion.value : '' }) }
              id = 'select_otra_institucion'
              nombre = { postuladas.length > 0 ? `Otra institución de la convocatoria (${otras.length})` : 'Seleccione la institución asignada' }
              placeholder = { `Buscar entre ${otras.length} institución(es)` }
              required = { false }
            />
          </Grid>
        }
        {
          estados_siguiente.length === 0 && universidades.length === 0 &&
          <Grid item xs = { 12 }>
            <List><ListSubheader component = "div" >No hay acciones disponibles para esta solicitud.</ListSubheader></List>
          </Grid>
        }
        {
          estado && estado !== "Est_Int_Cor" &&
            <Grid item xs = { 12 } md = { 12 }>
              <FormControl className = "form-control" >
                <TextField
                  value = { observacion }
                  id = "txtObservacion"
                  label = "Observaciones"
                  name = "observacion"
                  placeholder = "Digite observaciones de la solicitud"
                  multiline
                  onChange = { this.onChange }
                />
              </FormControl>
            </Grid>
        }
      </Grid>
    )
  }

  pintarOpccionesEditar() { 
    let { opciones_editar, data_opc_editar, observacion } = this.state;
    return (
      <Grid container>
        <Grid item xs = { 12 } xl = { 12 } sm = { 12 } md = { 12 } lg = { 12 }>
          <RenderOpcionesEditar
            cambiarSeleccion = { this.toggleSeleccion }
            estado = { opciones_editar }
            opciones = { data_opc_editar }
          />
        </Grid>
        {
          opciones_editar.length > 0 &&
            <Grid item xs = { 12 } md = { 12 }>
              <FormControl className = "form-control" >
                <TextField
                  value = { observacion }
                  id = "txtObservacionCorreccion"
                  label = "Observaciones"
                  name = "observacion"
                  placeholder = "Digite observaciones sobre las correcciones requeridas"
                  multiline
                  onChange = { this.onChange }
                />
              </FormControl>
            </Grid>
        }
      </Grid>
    )
  }

  toggleSeleccion = (codigo) => {
    this.setState((prevState) => {
      const { opciones_editar } = prevState;
      if (opciones_editar.includes(codigo)) {
        return { opciones_editar: opciones_editar.filter((estado) => estado !== codigo) };
      } else {
        return { opciones_editar: [...opciones_editar, codigo] };
      }
    });
  };

  reiniciarEstados() {
    this.setState({
      cargando: true,
      titulo_res: 'Cargando..',
      estado: '',
      estados_siguiente: [],
      seleccion: 'gestion',
      archivos: [],
      universidades: [],
      universidad_sel: '',
      universidad_actual: '',
    })
  }

  render () {
    let { modalGestionarSolicitud, mostrarModalGestionarSolicitud, solicitud } = this.props;
    let { seleccion, cargando, titulo_res, modal_correccion } = this.state;
    const mostrarDocumentos = !(
      solicitud &&
      solicitud.estado_actual && solicitud.estado_actual.codigo === 'Est_Int_Env' &&
      solicitud.tipo_solicitud && CODIGOS_TIPO_POSTULACION.indexOf(solicitud.tipo_solicitud.codigo) >= 0
    );
    return (
      <>
      <Dialog fullWidth = { true } maxWidth = "sm" open = { modalGestionarSolicitud } disableBackdropClick = { true } onClose = { () => { if (!cargando) mostrarModalGestionarSolicitud(false) } } aria-labelledby = "alert-dialog-title" aria-describedby="alert-dialog-description">
        <AppBarModal titulo = { '¿ Gestionar Solicitud ?' } mostrarModal = { () => { if (!cargando) mostrarModalGestionarSolicitud(false) } } titulo_accion = "" accion = "" />
        <MenuGestionarSolicitud seleccionar = { (seleccion) => this.setState({ seleccion }) } sele = { seleccion } />
        <DialogContent style = { { padding: '1' } } className = 'scroll'>
          {
            cargando ?
              <TareasTerminadas mensaje = { titulo_res } marginTop = '7%' imagen = { emma_w } widthImg = "7%" />
              : <div style = { { padding: "5px 0 5px 0" } }>{ this.pintar() }</div>
          }
        </DialogContent>
        <DialogActions>
          <BtnForm texto = "CANCELAR" callback = { () => { if (!cargando) mostrarModalGestionarSolicitud(false) } } />
          { !cargando && <BtnForm texto = "ACEPTAR" callback = { this.onSubmit } /> }
        </DialogActions>
        </Dialog>
        {
          modal_correccion &&
          <Dialog fullWidth={true} maxWidth="xs" open={modal_correccion} onClose={null} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <AppBarModal titulo={'¿ Parámetros a corregir ?'} mostrarModal={() => this.setState({modal_correccion: false, opciones_editar: [], estado: ''})} titulo_accion="" accion="" />
            <DialogContent style={{ padding: '1' }} className='scroll'>
              {
                cargando ?
                  <TareasTerminadas mensaje={titulo_res} marginTop='7%' imagen={emma_w} widthImg="7%" />
                  : <div style={{ padding: "5px 0 5px 0" }}>{this.pintarOpccionesEditar()}</div>
              }
            </DialogContent>
            <DialogActions>
              <BtnForm texto="CANCELAR" callback={() => this.setState({modal_correccion: false, opciones_editar: [], estado: '' })} />
              <BtnForm texto="ACEPTAR" callback={this.onSubmitMod} />
            </DialogActions>
          </Dialog>
        }

      </>
    )
  }
}

// Props del componente
SolicitudesGestionar.propTypes = {
  // Variables
  modalGestionarSolicitud: PropTypes.bool.isRequired,
  usuario: PropTypes.object.isRequired,
  // Funciones
  mostrarModalGestionarSolicitud: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  let { usuario } = state.redGlobal;
  return {
    usuario
  }
}

export default connect(mapStateToProps)(SolicitudesGestionar);
